import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function InlineTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-white text-gray-900 py-3 px-4 rounded-xl mb-6 flex items-center justify-center gap-3 border border-pastel-200 shadow-sm" data-id="element-239">
      <Clock className="w-5 h-5 animate-pulse text-pastel-600" data-id="element-240" />
      <span className="text-sm md:text-base font-medium" data-id="element-241">
        Esta oferta expira en:
      </span>
      <div className="flex items-center gap-1 font-mono font-bold text-lg md:text-xl" data-id="element-242">
        <span className="bg-pastel-100 text-pastel-800 px-2 py-1 rounded" data-id="element-243">
          {formatTime(minutes)}
        </span>
        <span className="animate-pulse text-pastel-600" data-id="element-244">:</span>
        <span className="bg-pastel-100 text-pastel-800 px-2 py-1 rounded" data-id="element-245">
          {formatTime(seconds)}
        </span>
      </div>
    </div>;
}